import { KPI_VALUE_PERCENT } from '@/utils/hooks/format/useFormatKpiValue';

// Utils
import faqUrl from '@/utils/urls/faqUrl';

import { colors } from '@/lib/analytics/colors';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_33 } from '@/lib/gridElements/size';
import { url_faq_twitter_analytics } from '@/lib/urls/faqUrls';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';
import { Trans } from '@/components/tools/translation';

export const avgEngagementOnImpressionsPerTweetConfig = {
    name: 'kpi.twitter.avg_engagement_on_impression',
    id: 'average_engagement_on_impressions_per_tweet',
    icon: {
        name: 'engagement-on',
        style: colors.green
    },
    tooltip: (
        <Trans
            i18nKey="analytics:kpi.twitter.tooltip_avg_engagement_on_impression"
            components={{
                br: <br />,
                tag0: (
                    // eslint-disable-next-line jsx-a11y/anchor-has-content
                    <a
                        className="text-icoBlue underline"
                        target="_blank"
                        href={faqUrl(url_faq_twitter_analytics)}
                        rel="help noopener noreferrer"
                    />
                )
            }}
        />
    ),
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_PERCENT,
    size: SIZE_33,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    element: KPIDefault,
    loader: DefaultLoader
};
